var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushPull = function SvgPushPull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71 2.864v5.885h-1V2.864L2.896 5.678 2.19 4.97l3.2-3.2h1.644l3.199 3.2-.707.707L6.71 2.864ZM10.29 13.136V7.251h-1v5.885l-2.814-2.814-.708.707 3.2 3.2h1.644l3.199-3.2-.707-.707-2.814 2.814Z",
    fill: "currentColor"
  })));
};
export default SvgPushPull;